import type { PerformanceLabBuyHrefOptions } from './utils';

export const RECOVERY_TREATMENT_BUY_ROUTES: Record<
  string,
  PerformanceLabBuyHrefOptions
> = {
  'iv-therapy': { category: 'iv-therapy' },
  'hyperbaric-oxygen-therapy-hbot': {
    category: 'standalone',
    planId: 'pl-standalone-hbot',
  },
  cryotherapy: { category: 'standalone', planId: 'pl-standalone-cryo' },
  'sports-massage': {
    category: 'standalone',
    planId: 'pl-standalone-massage-male',
  },
};
